bcp-stock-activity-indicator {
  display: block;
}
